var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"loadingSet",attrs:{"column":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"width":3,"color":"grey"}}),_c('h3',{staticClass:"pt-5 colorL"},[_vm._v("Cargando")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }